import type { ClientId } from './registry';

/**
 * The client this build runs as. **Change this line to switch clients.**
 *
 * Deliberately a committed constant rather than an environment variable: every
 * checkout and CI job must agree on which client it is building, and `.env` is
 * gitignored. Typed as `ClientId`, so a name that isn't in the registry is a
 * compile error, not a silent fallback at runtime.
 *
 * Read by `src/clients/index.ts` for the app and by `vite.config.ts` for the
 * asset overlay and PWA manifest, so both sides can never disagree.
 */
export const ACTIVE_CLIENT_ID: ClientId = 'df';
